// The catch-all: `/` and every path that isn't /s/<token> or /admin… render this
// and nothing else.
//
// No text, no navigation, no link to /admin — the admin surface is unlinked on
// purpose, and a "sign in" button here would undo that. No redirect either: a
// bounce to the corporate site tells a crawler this host belongs to something,
// where a picture tells it nothing.

// Served from frontend/public/, so Vite copies it into the build untouched.
// NOTE: the source file is 3840×2160 and ~9.8 MB — fine on a desktop, slow on a
// phone. Downscale it (or add a smaller companion + srcset) if this page ever
// matters for more than looking like nothing.
const COVER_SRC = '/capston-cover.png'

export default function CoverPage() {
  return (
    <main className="cover">
      <img
        src={COVER_SRC}
        alt="Capston"
        className="cover__image"
        width="3840"
        height="2160"
        fetchPriority="high"
        decoding="async"
      />
    </main>
  )
}
